import i18n from 'i18next';

const setHtmlLang = (lng) => {
  if (!lng) return;
  const [lang] = String(lng).split('-');
  document.documentElement.lang = lang;
};

// initialize once
setHtmlLang(i18n.language);

// keep in sync for future changes
i18n.on('languageChanged', setHtmlLang);
